import React, { useCallback, useEffect, useRef } from 'react';

const Testpage = () => {

const testRef = useRef(null)

const scrollPage = useCallback(async()=>{
  // const {clientHeight, scrollHeight, scrollTop} = testRef.current;
// console.log(clientHeight, " clientHeight")
// console.log(scrollHeight, " scrollHeight")
// console.log(scrollTop, " scrollTop")
// console.log(window.scrollY, " window scroll position");
},[])


  // useEffect(() => {
  //   window.addEventListener('scroll', scrollPage);
  //   return () => window.removeEventListener('scroll', scrollPage);
  // }, [scrollPage]);

const HINDI_TEXT = {
    title: "जन गण मन",
    stanza: "जन गण मन अधिनायक जय हे,\nभारत भाग्य विधाता।\nपंजाब सिन्ध गुजरात मराठा,\nद्राविड़ उत्कल बंग।\nविंध्य हिमाचल यमुना गंगा,\nउच्छल जलधि तरंग।\nतव शुभ नामे जागे,\nतव शुभ आशीष मांगे,\nगाहे तव जय गाथा।\nजन गण मंगल दायक जय हे,\nभारत भाग्य विधाता।\nजय हे, जय हे, जय हे,\nजय जय जय जय हे।"
};

  return (<div className="py-48 px-4" ref={testRef} onScroll={scrollPage} style={{ height: '400px' }}>
      <div className="min-h-screen bg-gray-50 p-4 sm:p-8 flex flex-col items-center">
            {/* 1. FONT LOADING: Load a reliable Hindi font (Noto Sans Devanagari) */}
            {/* The primary fix for blurry/broken characters is ensuring the font supports the script. */}
            <link 
                href="https://fonts.googleapis.com/css2?family=Inter:wght@400;700&family=Noto+Sans+Devanagari:wght@400;700&display=swap" 
                rel="stylesheet" 
            />
            
            <header className="w-full max-w-3xl mb-8">
                <h1 className="text-3xl sm:text-4xl font-bold text-center text-gray-800 font-inter">
                    Hindi Text Clarity Demonstration
                </h1>
                <p className="text-center text-gray-500 mt-2">Applying best practices for Devanagari script rendering.</p>
            </header>

            <div className="w-full max-w-3xl space-y-8">                
                {/* GOOD EXAMPLE: Proper Font Loading and CSS */}
                <div className="bg-white rounded-xl shadow-xl p-6 sm:p-10 border-t-4 border-blue-500">
                    <h2 className="text-2xl font-semibold mb-4 text-blue-600">
                        Solution Applied (Best Practice)
                    </h2>
                    <h3 className="text-xl font-bold mb-3 hindi-font text-gray-900">
                        {HINDI_TEXT.title}
                    </h3>
                    <pre className="hindi-font text-gray-800 whitespace-pre-wrap leading-relaxed">
                        {HINDI_TEXT.stanza}
                    </pre>
                    <div className="mt-6 p-3 bg-blue-50 rounded-lg text-sm text-blue-800">
                        <p className="font-semibold">Key Fixes Applied:</p>
                        <ul className="list-disc list-inside mt-1 space-y-1">
                            <li><span className="font-medium">Reliable Font:</span> Using <span className="font-mono text-xs bg-blue-100 px-1 rounded">Noto Sans Devanagari</span>.</li>
                            <li><span className="font-medium">Sufficient Line Height:</span> <span className="font-mono text-xs bg-blue-100 px-1 rounded">line-height: 1.65</span> for clear stacked characters.</li>
                        </ul>
                    </div>
                </div>

                {/* VISUAL COMPARISON: Small Text (Common issue on mobile) */}
                <div className="bg-white rounded-xl shadow-xl p-6 sm:p-10 border-t-4 border-red-500">
                    <h2 className="text-2xl font-semibold mb-4 text-red-600">
                        Potential Problem Area (Too Small Text)
                    </h2>
                    <p className="text-sm font-light text-red-700 mb-3">
                        When the font size is too small, complex characters lose clarity.
                    </p>
                    <h3 className="text-lg font-bold mb-2 hindi-font text-gray-900">
                        {HINDI_TEXT.title}
                    </h3>
                    <p className="hindi-font text-xs text-gray-800">
                        {HINDI_TEXT.stanza.split('\n').slice(0, 3).join(' ')}...
                    </p>
                </div>
                
            </div>
            
            <footer className="mt-10 text-center text-gray-500 text-sm max-w-3xl">
                <p>
                    *Always ensure your main HTML file contains <code className="bg-gray-200 px-1 rounded text-xs">&lt;meta charset="UTF-8"&gt;</code> in the <code className="bg-gray-200 px-1 rounded text-xs">&lt;head&gt;</code> tag. This ensures the browser understands the raw Devanagari characters.
                </p>
            </footer>
        </div>
     
    </div>
  );
};

export default Testpage;
